import {base} from './base';

export const apothecary = base
  .extend('Apothecary')
  // Colors
  .property('primary.color', '#EFE4E7')
  .property('primary.font', 'Playfair Display')

  // border radius
  .property('border.radius', '0px')

  // Page
  .property('page.background.color', '#292E2A')

  // Text
  .property('text.font', 'Palanquin')
  .property('text.color', '#EFE4E7')

  // Menu
  .property('menu.background.color', '#292E2A')
  .property('menu.text.color', '#EFE4E7')
  .property('menu.text.font', 'Playfair Display')
  .property('menu.text.transform', 'none')

  // Image
  .property(
    'image.default',
    'https://images.teemill.com/ewme4veikramed18d4ywblmrj8raxb38zsbsvnxug2vxuib1.jpeg'
  )

  // Buttons
  .property('button.primary.color', '#5D604E')

  // Quote
  .property('quote.text.color', '#292E2A')
  .property('quote.fullBackground.color', '#EFE4E7')

  // AnnouncementV2
  .property('announcement.v2.text.color', '#292E2A')
  .property('announcement.v2.background.color', '#EFE4E7')

  // Newsletter
  .property('newsletter.text.color', '#EFE4E7')
  .property('newsletter.fullBackground.color', '#5D604E')

  //Footer
  .property('footer.text.color', '#EFE4E7')
  .property('footer.background.color', '#292E2A');
